"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var utilities_1 = require("../helpers/utilities");
var addToBag_1 = __importDefault(require("./addToBag"));
var Metred = /** @class */ (function () {
    function Metred() {
        this.config = {
            currentVariant: null,
            products: null,
            custom: null,
            //gets metered set by metafield in product-metred.liquid
            metered_metafield: window.metered,
            option2: {
                hasOption2: false,
                name: null,
                values: null
            }
        };
    }
    Metred.prototype.init = function () {
        return __awaiter(this, void 0, Promise, function () {
            var form, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        form = document.querySelector('[data-add-to-cart]');
                        container = document.querySelector('[data-metred]');
                        if (!form || !container)
                            return [2 /*return*/];
                        addToBag_1.default.enabled(false, form);
                        return [4 /*yield*/, this.load(form, container)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    Metred.prototype.load = function (form, container) {
        return __awaiter(this, void 0, Promise, function () {
            var response, pattern, products, productOptions, customProduct, enabled;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = {
                            data: this.config.metered_metafield
                        };
                        pattern = container.dataset.pattern;
                        return [4 /*yield*/, this.products(response, pattern)];
                    case 1:
                        products = _a.sent();
                        productOptions = {};
                        if (products.length) {
                            products.forEach(function (product) {
                                var options = product.data.options;
                                if (options.length == 2) {
                                    _this.config.option2.hasOption2 = true;
                                    var option2_1 = options[1];
                                    if (Object.keys(productOptions).indexOf(option2_1.name) == -1) {
                                        productOptions[option2_1.name] = [];
                                        _this.config.option2.name = option2_1.name;
                                    }
                                    option2_1.values.forEach(function (value) {
                                        if (productOptions[option2_1.name].indexOf(value) == -1) {
                                            productOptions[option2_1.name].push(value);
                                        }
                                    });
                                }
                            });
                            if (this.config.option2.hasOption2) {
                                this.config.option2.values = this.sortWidths(productOptions[this.config.option2.name]);
                                console.log(this.config.option2);
                            }
                        }
                        if (!(response.data.pricing.custom[pattern] && response.data.pricing.custom[pattern].length)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.customProduct(response, pattern)];
                    case 2:
                        customProduct = _a.sent();
                        _a.label = 3;
                    case 3:
                        this.config.currentVariant = this.getVariant(response.data.settings.byMetreLengthMin, products);
                        this.updateSelected();
                        enabled = this.config.currentVariant ? this.checkQuantity(this.config.currentVariant.option1) : false;
                        if (customProduct && customProduct.length) {
                            this.renderPresetLengthSelect(container, response, customProduct[0].data.variants);
                        }
                        else if (this.config.option2.hasOption2) {
                            this.renderOption2(container, response);
                        }
                        else
                            this.render(container, response);
                        this.addEventListeners(container, products, customProduct, form);
                        addToBag_1.default.updateVariant(form, this.config.currentVariant);
                        addToBag_1.default.enabled(enabled, form, this.config.currentVariant);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    Metred.prototype.settings = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Promise).resolve;
                        return [4 /*yield*/, (0, axios_1.default)({
                                method: 'GET',
                                responseType: 'json',
                                url: '/pages/settings'
                            })];
                    case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()])];
                }
            });
        });
    };
    Metred.prototype.addEventListeners = function (container, products, customProduct, form) {
        var _this = this;
        var inputs = container.querySelectorAll('input');
        inputs.forEach(function (input) { return input.addEventListener('change', function (e) { _this.handleChange(e, products, form); }); });
        inputs.forEach(function (input) { return input.addEventListener('keyup', _this.handleKeyUp); });
        if (this.config.option2.hasOption2) {
            var selects = container.querySelectorAll('select');
            selects.forEach(function (select) { return select.addEventListener('change', function (e) { _this.handleChange(e, products, form); }); });
        }
        if (customProduct) {
            var selects = container.querySelectorAll('select');
            selects.forEach(function (select) { return select.addEventListener('change', function (e) { _this.handleChange(e, customProduct, form); }); });
        }
    };
    Metred.prototype.products = function (response, pattern) {
        return __awaiter(this, void 0, Promise, function () {
            var products;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        products = [];
                        return [4 /*yield*/, Promise.all(response.data.pricing.metred[pattern].map(function (handle) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _b = (_a = products).push;
                                            return [4 /*yield*/, (0, axios_1.default)({
                                                    method: 'GET',
                                                    responseType: 'json',
                                                    url: "/products/".concat(handle, ".js")
                                                })];
                                        case 1:
                                            _b.apply(_a, [_c.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.config.products = products;
                        return [2 /*return*/, products];
                }
            });
        });
    };
    //
    Metred.prototype.customProduct = function (response, pattern) {
        return __awaiter(this, void 0, Promise, function () {
            var custom;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        custom = [];
                        return [4 /*yield*/, Promise.all(response.data.pricing.custom[pattern].map(function (handle) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _b = (_a = custom).push;
                                            return [4 /*yield*/, (0, axios_1.default)({
                                                    method: 'GET',
                                                    responseType: 'json',
                                                    url: "/products/".concat(handle, ".js")
                                                })];
                                        case 1:
                                            _b.apply(_a, [_c.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.config.custom = custom;
                        return [2 /*return*/, custom];
                }
            });
        });
    };
    Metred.prototype.render = function (element, settings) {
        element.insertAdjacentHTML('afterbegin', "\n      <div class=\"product-metred\">\n        <div class=\"product-metred__group\">\n          <label class=\"product-metred__label\">Length (Min ".concat(settings.data.settings.byMetreLengthMin, "m, Max ").concat(settings.data.settings.byMetreLengthMax, "m)</label>\n          <div class=\"product-metred__input-wrapper\">\n            <input\n              class=\"product-metred__input\"\n              type=\"number\"\n              data-length\n              step=\"").concat(settings.data.settings.byMetreInterval, "\"\n              min=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n              max=\"").concat(settings.data.settings.byMetreLengthMax, "\"\n              value=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n            />\n            <div class=\"stepper\">\n              <span class=\"up\">\n               <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"/></svg>\n              </span>\n              <span class=\"down\">\n                <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13H5v-2h14v2z\"/></svg></span>\n            </div>\n            <span class=\"product-metred__icon\">m</span>\n          </div>\n        </div>\n      </div>\n    "));
        var up = element.querySelector('.stepper .up');
        var down = element.querySelector('.stepper .down');
        var input = element.querySelector('input');
        var interval = parseFloat(settings.data.settings.byMetreInterval);
        up.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value < parseFloat(settings.data.settings.byMetreLengthMax)) {
                var newValue = value + interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
        down.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value > parseFloat(settings.data.settings.byMetreLengthMin)) {
                var newValue = value - interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
    };
    Metred.prototype.renderOption2 = function (element, settings) {
        var option = this.config.option2.values;
        var select = document.createElement('select');
        select.classList.add('product-options__select');
        select.classList.add('metred');
        select.setAttribute('data-product-options', this.config.option2.name);
        select.id = 'option-2-' + this.config.option2.name;
        option.forEach(function (option, index) {
            var el = document.createElement('option');
            el.innerText = option;
            el.classList.add('product-options__value');
            el.classList.add('product-options__value--');
            el.setAttribute('data-product-option', '');
            el.setAttribute('data-product-option-value', option);
            el.setAttribute('data-product-option-position', index);
            // el.setAttribute('data-product-option-variant-id', option)
            select.appendChild(el);
        });
        element.insertAdjacentHTML('afterbegin', "\n    <div class=\"product-metred\">\n      <div class=\"product-metred__group\">\n        <label class=\"product-metred__label\">Length (Min ".concat(settings.data.settings.byMetreLengthMin, "m, Max ").concat(settings.data.settings.byMetreLengthMax, "m)</label>\n        <div class=\"product-metred__input-wrapper\">\n          <input\n            class=\"product-metred__input\"\n            type=\"number\"\n            data-length\n            step=\"").concat(settings.data.settings.byMetreInterval, "\"\n            min=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n            max=\"").concat(settings.data.settings.byMetreLengthMax, "\"\n            value=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n          />\n          <div class=\"stepper\">\n          <span class=\"up\">\n           <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"/></svg>\n          </span>\n          <span class=\"down\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13H5v-2h14v2z\"/></svg></span>\n        </div>\n          <span class=\"product-metred__icon\">m</span>\n        </div>\n  \n      </div>\n    </div>\n\n    <div class=\"product-details__options\"> \n      <div class=\"product-options product-options--select\">  \n        <label class=\"product-options__label metred\" for=\"").concat(select.id, "\">\n            Please Choose a <span style=\"text-transform: lowercase\">").concat(this.config.option2.name, "</span>\n         </label>\n         ").concat(select.outerHTML, "\n      </div>\n    </div>\n    "));
        var up = element.querySelector('.stepper .up');
        var down = element.querySelector('.stepper .down');
        var input = element.querySelector('input');
        var interval = parseFloat(settings.data.settings.byMetreInterval);
        up.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value < parseFloat(settings.data.settings.byMetreLengthMax)) {
                var newValue = value + interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
        down.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value > parseFloat(settings.data.settings.byMetreLengthMin)) {
                var newValue = value - interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
    };
    Metred.prototype.renderPresetLengthSelect = function (element, settings, variants) {
        var options = variants;
        var select = document.createElement('select');
        select.classList.add('product-options__select');
        select.classList.add('metred');
        select.setAttribute('data-product-options', 'select');
        select.id = 'preset-length';
        // default 
        var el = document.createElement('option');
        el.innerText = "No Selection";
        el.classList.add('product-options__select');
        el.setAttribute('data-product-option', '');
        el.setAttribute('data-product-option-value', "");
        el.setAttribute('data-product-option-position', '0');
        el.setAttribute('data-product-option-variant-id', "");
        select.appendChild(el);
        options.forEach(function (option, index) {
            var el = document.createElement('option');
            el.innerText = option.title;
            el.classList.add('product-options__value');
            el.classList.add('product-options__value--');
            el.setAttribute('data-product-option', '');
            el.setAttribute('data-product-option-value', option.title);
            el.setAttribute('data-product-option-position', index + 1);
            el.setAttribute('data-product-option-variant-id', option.id);
            select.appendChild(el);
        });
        element.insertAdjacentHTML('afterbegin', "\n    <div class=\"product-metred\">\n      <div class=\"product-metred__group\">\n        <label class=\"product-metred__label\">Length (Min ".concat(settings.data.settings.byMetreLengthMin, "m, Max ").concat(settings.data.settings.byMetreLengthMax, "m)</label>\n        <div class=\"product-metred__input-wrapper\">\n          <input\n            class=\"product-metred__input\"\n            type=\"number\"\n            data-length\n            step=\"").concat(settings.data.settings.byMetreInterval, "\"\n            min=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n            max=\"").concat(settings.data.settings.byMetreLengthMax, "\"\n            value=\"").concat(settings.data.settings.byMetreLengthMin, "\"\n          />\n          <div class=\"stepper\">\n          <span class=\"up\">\n           <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\"/></svg>\n          </span>\n          <span class=\"down\">\n            <svg xmlns=\"http://www.w3.org/2000/svg\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M19 13H5v-2h14v2z\"/></svg></span>\n        </div>\n          <span class=\"product-metred__icon\">m</span>\n        </div>\n  \n      </div>\n    </div>\n\n    <div class=\"product-details__options\"> \n      <div class=\"product-options product-options--select\">  \n        <label class=\"product-options__label metred\" for=\"").concat(select.id, "\">\n            Or please select from: \n         </label>\n         ").concat(select.outerHTML, "\n      </div>\n    </div>\n    "));
        var up = element.querySelector('.stepper .up');
        var down = element.querySelector('.stepper .down');
        var input = element.querySelector('input');
        var interval = parseFloat(settings.data.settings.byMetreInterval);
        up.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value < parseFloat(settings.data.settings.byMetreLengthMax)) {
                var newValue = value + interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
        down.addEventListener('click', function (e) {
            var value = parseFloat(input.value);
            if (value > parseFloat(settings.data.settings.byMetreLengthMin)) {
                var newValue = value - interval;
                input.value = newValue.toFixed(1);
                var event = new Event('change');
                input.dispatchEvent(event);
            }
        });
    };
    Metred.prototype.handleChange = function (e, products, form) {
        var el = e.target;
        // new option width
        if (this.config.option2.hasOption2) {
            var length = document.querySelector('[data-length]');
            var formattedLength = length.value.includes('.') ? "".concat(length.value, "m") : "".concat(length.value, ".0m");
            var option2 = document.querySelector("[data-product-options=\"".concat(this.config.option2.name, "\"]"));
            var formattedOption = "".concat(formattedLength, " / ").concat(option2.value);
            this.config.currentVariant = this.getVariantWithOption2(formattedOption, products);
            var enabled = this.config.currentVariant ? this.checkQuantity(this.config.currentVariant.option1) : false;
            addToBag_1.default.enabled(enabled, form, this.config.currentVariant);
            addToBag_1.default.updateVariant(form, this.config.currentVariant);
            this.updateSelected();
            return;
        }
        // original stepper
        else if (el.classList.contains('product-metred__input')) {
            var length = document.querySelector('[data-length]');
            this.config.currentVariant = this.getVariant(length.value, products);
            var enabled = this.config.currentVariant ? this.checkQuantity(this.config.currentVariant.option1) : false;
            addToBag_1.default.enabled(enabled, form, this.config.currentVariant);
            addToBag_1.default.updateVariant(form, this.config.currentVariant);
            this.updateSelected();
        }
        //look up custom preset selections. 
        else if (el.classList.contains('product-options__option')) {
            var variantId = el.selectedOptions[0].dataset.productOptionVariantId;
            if (variantId) {
                this.config.currentVariant = this.getCustomVariant(variantId, products);
                var enabled = this.config.currentVariant ? this.checkQuantity(this.config.currentVariant.option1) : false;
                addToBag_1.default.enabled(enabled, form, this.config.currentVariant);
                addToBag_1.default.updateVariant(form, this.config.currentVariant);
                this.updateSelected('- Selected Option');
            }
            else {
                // fake onchange event
                var length = document.querySelector('[data-length]');
                if ("createEvent" in document) {
                    var evt = document.createEvent("HTMLEvents");
                    evt.initEvent("change", false, true);
                    length.dispatchEvent(evt);
                }
                else
                    length.fireEvent("onchange");
            }
        }
    };
    Metred.prototype.checkQuantity = function (title) {
        var container = document.querySelector('[data-metred][data-metred-quantity]');
        var quantity = parseInt(container.dataset.metredQuantity);
        var area = (0, utilities_1.calcQuantityByArea)(title);
        return area <= quantity ? true : false;
    };
    Metred.prototype.handleKeyUp = function (event) {
        var target = event.currentTarget;
        var split = target.value.split('.');
        var value = target.value;
        var decimalValue;
        if (split.length > 1)
            decimalValue = split[1].substring(0, 1);
        if (decimalValue)
            value = split[0] + '.' + decimalValue;
        target.value = value;
    };
    Metred.prototype.getVariant = function (length, products) {
        var formattedValue = length.includes('.') ? "".concat(length, "m") : "".concat(length, ".0m");
        var currentVariant = this.config.currentVariant;
        products.forEach(function (product) {
            var variant = product.data.variants.find(function (variant) { return variant.option1 === formattedValue; });
            if (variant)
                currentVariant = variant;
        });
        return currentVariant;
    };
    Metred.prototype.getCustomVariant = function (variantId, products) {
        var currentVariant = this.config.currentVariant;
        products.forEach(function (product) {
            var variant = product.data.variants.find(function (variant) { return variant.id == variantId; });
            if (variant)
                currentVariant = variant;
        });
        return currentVariant;
    };
    Metred.prototype.getVariantWithOption2 = function (variantName, products) {
        var currentVariant = this.config.currentVariant;
        products.forEach(function (product) {
            var variant = product.data.variants.find(function (variant) { return variant.title.trim() == variantName.trim(); });
            if (variant)
                currentVariant = variant;
        });
        return currentVariant;
    };
    Metred.prototype.updateSelected = function (text) {
        if (text === void 0) { text = ""; }
        var p = document.querySelector('.product-details__subtitle');
        if (p) {
            p.innerText = this.config.currentVariant.title + " " + text;
        }
        else {
            var el = document.querySelector('.product-details__title');
            el.insertAdjacentHTML('beforeend', "\n      <p class=\"product-details__subtitle\" style=\"margin-top: 3px; \"> ".concat(this.config.currentVariant.title + " " + text, "</p>\n      "));
        }
    };
    Metred.prototype.sortWidths = function (widths) {
        return widths.map(function (w) { return parseFloat(w); }).sort(function (a, b) { return a - b; }).map(function (f) { return f + '.0cm'; });
    };
    return Metred;
}());
exports.default = new Metred();
